import { render, staticRenderFns } from "./AddProgressNote.vue?vue&type=template&id=45af37cd&scoped=true&"
import script from "./AddProgressNote.vue?vue&type=script&lang=js&"
export * from "./AddProgressNote.vue?vue&type=script&lang=js&"
import style0 from "./AddProgressNote.vue?vue&type=style&index=0&id=45af37cd&prod&lang=less&scoped=true&"
import style1 from "./AddProgressNote.vue?vue&type=style&index=1&id=45af37cd&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45af37cd",
  null
  
)

export default component.exports